<template>
  <label class="lang-select">
    <select
      class="lang-select-input"
      :aria-label="t('nav.language')"
      :value="locale"
      @change="onChange"
    >
      <option value="en">English</option>
      <option value="es">Español</option>
      <option value="pt">Português</option>
    </select>
    <svg
      class="lang-select-chevron"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      aria-hidden="true"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M6 9l6 6 6-6"
      />
    </svg>
  </label>
</template>

<script setup lang="ts">
import { useI18n } from '../i18n/t'
import type { AppLocale } from '../stores/locale'

const { t, locale, setLocale } = useI18n()

function onChange(event: Event): void {
  const value = (event.target as HTMLSelectElement).value
  if (value === 'en' || value === 'es' || value === 'pt') {
    setLocale(value as AppLocale)
  }
}
</script>

<style scoped>
.lang-select {
  position: relative;
  display: inline-flex;
  align-items: center;
  margin: 0;
}

.lang-select-input {
  appearance: none;
  -webkit-appearance: none;
  height: 36px;
  margin: 0;
  padding: 0 32px 0 14px;
  border: 1px solid var(--md-sys-color-outline-variant);
  border-radius: 18px;
  background: transparent;
  color: var(--md-sys-color-on-surface);
  font: inherit;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.2px;
  cursor: pointer;
}

.lang-select-input:hover {
  background: var(--md-state-layer);
}

.lang-select-input:focus-visible {
  outline: 2px solid var(--md-sys-color-primary);
  outline-offset: 2px;
}

.lang-select-chevron {
  position: absolute;
  right: 10px;
  width: 16px;
  height: 16px;
  pointer-events: none;
  color: var(--md-sys-color-on-surface-variant);
}
</style>
